<template>
    <flex-container
        justify-content="center"
        align-items="center"
        :gap="Size.sm"
        :padding="Size.sm"
    >
        <img
            class="preview-footer-image"
            src="@/assets/images/openai-logo.png"
            alt="OpenAI logo"
        />
        <text-decorator
            :size="FontSize.xs"
            :color="'gray-500'"
        >
            Model: gpt-4o
        </text-decorator>
        <text-decorator
            :size="FontSize.xs"
            :color="'gray-500'"
        >
            AssistentID:
            <template v-if="inDevelopment">
                <a
                    :href="`https://platform.openai.com/assistants/${props.assistentId}`"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {{ props.assistentId }}
                </a>
            </template>
            <template v-else>
                {{ props.assistentId }}
            </template>
        </text-decorator>
    </flex-container>
</template>

<script setup lang="ts">
    import { FontSize, Size } from '@keyvue/one-ui';
    import { computed } from 'vue';

    export interface Props {
        assistentId: string,
    }

    const props = defineProps<Props>();
    const inDevelopment = computed(() => {
        return import.meta?.env?.MODE === 'development';
    });
</script>

<style scoped lang="scss">
.preview-footer-image {
    width: 100px;
}
</style>
